import React, { PureComponent } from 'react';
import { Button, Grid, Typography, Theme, createStyles, WithStyles, withStyles } from '@material-ui/core';
import { getFormattedDates } from '../../../../treeComponents/helper';
import { PreviewTree } from './index';
import { formatterConvertorForCourse } from '../../../../treeComponents/helper/FormatConvertorForCourse';
import SearchBarWithChips from '../../../../../common/SearchBarWithChips';
import { connect } from 'react-redux';
import { MyPATDialog, MyPATTextField, MyPATTextArea, MyPATDropdown } from '../../../../../../common';
import MyPATCalendar from '../../../../../../common/MyPATCalendar';
import { bindActionCreators } from 'redux';
import { contentManagementService } from '../../../../../service';
import { contentManagementAction } from '../../../../../reducers/contentMangementData';
import _ from 'lodash';
import courseService from '../../../../../../course/services/courseService';
import ACLService from '../../../../../../acl/services/aclService';
import { withRouter } from "react-router";
import { CourseTypes } from '../../../../../types/enums/CourseTypes';
import PreviewTest from './PreviewTest';
import { styles } from './styles';
import { checkForDuplicateChapters } from '../../../../treeComponents/component/helpers/isLastInstanceOfChapter';
import { classNames } from '@react-pdf-viewer/core';
import { convertToDateTimeString, getRequestId, redirectToCourseRequest } from '../../../../../helpers/helpers';
import RequestStatus from '../../../../../containers/components/RequestStatus';

interface CoursePlanPreviewProps extends WithStyles<typeof styles> {
  classes: any;
  match: any;
  setViewPlanData: Function;
  viewPlanData: any;
  history: any;
  showVersionPopup: boolean;
  toggleVersionPopup: () => void;
  packageByIdData: any;
  setTreeData:Function;
  treeData: any;
}

interface CoursePlanPreviewState {
  subjectSelection: string;
  packageResponse: any;
  goalList: any;
  formData: {
    masterId: string;
    name: string;
    sku: string;
    skuText: string;
    skuNumber: number | string;
    expiryDate: string;
    startDate: string;
    onboardingInterval: {
      startDate: string;
      endDate: string;
    };
    packageAdmins: any;
    courseDetails: any;
    includedPackages: any;
    description: string;
    type: string;
    goalLevels: any;
    phaseAlignment: any;
    targetYears: any;
  };
   goalName:{value: string, label: string, id: string}[];
  activeTab: any;
  requests: any;
}
class CoursePlanPreview extends PureComponent<CoursePlanPreviewProps, CoursePlanPreviewState> {
  constructor(props: CoursePlanPreviewProps) {
    super(props);
    this.state = {
      subjectSelection: 'All Subjects',
      packageResponse: {},
      goalList: [],
      formData: {
        masterId: '',
        name: '',
        sku: '',
        skuText: '',
        skuNumber: 0,
        expiryDate: '',
        startDate: '',
        onboardingInterval: {
          startDate: '',
          endDate: '',
        },
        packageAdmins: [],
        courseDetails: [],
        includedPackages: [],
        description: '',
        type: '',
        goalLevels: [],
        phaseAlignment: {
          id: '',
          name: '',
          startDate: '',
          endDate: '',
        },
        targetYears: [],

      },
      goalName: [],
      activeTab: 0,
      requests: {}
    };
  }
  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const id = params.id;
    const userData = ACLService.getUserDetailsFromStorage();
    courseService.fetchPackageListById(id).then((res:any) => {
      const updatedFormData = { ...this.state.formData };
      updatedFormData.name = res.name;
      updatedFormData.masterId = res._id;
      updatedFormData.expiryDate = res.exipryDate;
      updatedFormData.startDate = res.startDate
      if (res.hasOwnProperty('coursePlanId') && res.coursePlanId && res.status !== 'DRAFT') {
        this.setState({
          packageResponse: res,
          formData: updatedFormData,
        });
        res &&
          res.coursePlanId &&
          contentManagementService.getCousePlanApiById(res.coursePlanId).then(({ coursePlan, requests = [] }) => {
            const updatedFormData = { ...this.state.formData };
            
            updatedFormData.type = coursePlan.type;
            this.props.setViewPlanData({
              viewPlanData: JSON.parse(JSON.stringify(coursePlan)),
            });
            this.props.setTreeData({
              treeData: coursePlan,
            });

            const newRequest: any = {
              awaiting: [],
              approved: [],
              rejected: []
            };
            requests.forEach((request: any) => {
              const status = request.status;
              if(!newRequest[status]){
                newRequest[status]=[]
                }

              newRequest[status].push({
                ...request,
                updatedAt: convertToDateTimeString(request.updatedAt)
              });
            });
            this.setState({ formData: updatedFormData, requests: newRequest });
          });
        const goalLevel = _.get(res.courseDetails, '[0].courseType.id');
        //5fd308af4c67470ee83486ea JEE(L10) - 2024 remove after use
        contentManagementService.getGoalLevel(goalLevel).then((res: any) => {
          let valuelist: any = [];
          res.goalLevels.forEach((ele: any) => {
            let element = { id: ele._id, label: ele.name, value:ele.name,isRemovable:true};
            valuelist.push(element);
          });
          this.setState({
            goalList: valuelist,
          });
        });
      } else {
        
        const createdType = res && res.includedPackages && res.includedPackages.length ? 'Standard Course' : 'Goals';
        switch (res.type) {
          case 'combo':
            this.props.history.push(`/course-Management/create-combo-course/${id}/${createdType}`);
            break;
          case 'standard':
            this.props.history.push(`/course-Management/create-standard-course/${id}`);
            break;
        }
      }
      // return res;
    });
  }


  onEdit = () => {
    const courseId = _.get(this.state, 'packageResponse._id', '');
    const coursePlanId = _.get(this.state, 'packageResponse.coursePlanId', '');
    const type = _.get(this.state, 'packageResponse.type', 'standard');
    let route;
    switch (type) {
      case CourseTypes.standard: {
        route = 'create-standard-course';
        break;
      }
      case CourseTypes.combo: {
        route = 'create-combo-course';
        break;
      }
      case CourseTypes.testSeries: {
        route = 'create-combo-course';
        break;
      }
      default:
        route = 'testSeries';
        break;
    }
    this.props.history.push(`/course-Management/${route}/${courseId}?coursePlanId=${coursePlanId}`);
  };

  handleDisableversion = () => {
    const { formData } = this.state;
    const phaseAlignment = { ...formData.phaseAlignment };
    const onBoarding = { ...formData.onboardingInterval };
    if (
      formData.name == '' ||
      formData.skuNumber === '' ||
      formData.skuText === '' ||
      phaseAlignment.name === ''
    ) {
      return true;
    } else {
      return false;
    }
  };
  createVersion = () => {
    const { history } = this.props;
    let payload = { ...this.state.formData };
    const { packageResponse } = this.state;
    if (payload.goalLevels.length === 0) {
      //@ts-ignore
      delete payload.goalLevels;
      //goallevels
      //name populate done
      //calender done
      //sku type number done
    }
    payload.targetYears = [2025];
    payload.expiryDate = packageResponse.expiryDate;
    payload.courseDetails = packageResponse.courseDetails;
    payload.includedPackages = packageResponse.includedPackages;
    payload.packageAdmins = packageResponse.packageAdmins;
    contentManagementService.updateVersion(payload).then((res: any) => {
      let responseId = _.get(res, 'packageDetails._id', '');
      let masterId = payload.masterId;
      if (responseId) {
        // history.push(`/course-Management/create-standard-course/`+responseId)
        history.push(`/course-Management/create-standard-course/${responseId}?masterId=${masterId}&type=version`);
        // return res
        this.props.toggleVersionPopup()
      }
    });
  };
  handleDescriptionChange = (event: any) => {
    const response = { ...this.state.formData };
    response.description = event.target.value;
    this.setState({
      formData: response,
    });
  };

  handlePhaseChange = (selectedData: string) => {
    const { viewPlanData } = this.props;
    const phaseFormData = { ...this.state.formData };
    const selectedDataName = selectedData.split(" Ownwards")
    viewPlanData.phases.forEach((requiredData:any)=>{
   if(requiredData.name == selectedDataName[0].toString()){
    let phaseAlignment = {
      id: requiredData._id,
      name: requiredData.name,
      startDate: requiredData.startDate,
      endDate: requiredData.endDate,
    };
    phaseFormData.phaseAlignment = phaseAlignment;
  }
  
})

   
    this.setState({ formData: phaseFormData });
  }
  // getDisplayValue=(data:any)=>{
  //   debugger
  //  if(data.id){
  //   const result = data._id + " Onwards " + data.startDate;
  //   return result
  //  } else{
  //   return
  //  }

  // }
  viewPhaseData=()=>{
    const {viewPlanData } = this.props
    let viewPhase:any =[];

   viewPlanData && viewPlanData.phases && viewPlanData.phases.forEach((data:any)=>{
     let date = new Date(data.startDate)
      const month =["January","february","March","April","May","June","Jully","August","September","October","November","December"]
     let startDate = date.getDate()+" " + month[date.getMonth()] +" "+date.getFullYear()
      let phaseAlignment = data.name.toString() +" Ownwards " + startDate
      viewPhase.push(phaseAlignment)
    })
    return viewPhase 
  }
  handleChange = (event: any) => {
    //const {packageResponse } = this.state;
    const response = { ...this.state.formData };
    let { name, value } = event.target;
    switch (name) {
      case 'versionName':
        //  value = value.replace(/[^\w\s]/gi, "");
        response.name = value;
        break;
      case 'skuText':
        // let skuValue = this.state.packageResponse.sku;
        // const skutext = _.split(response.sku,'-');
        // skuValue = _.concat(value,skutext[1],skutext[2])
        response.skuText = value;
        break;
      case 'skuNumber':
        // let skuValueNumber = this.state.packageResponse.sku;
        // const skuNumber = _.split(response.sku,'-');
        // skuValueNumber = _.concat(value,skuNumber[1],skuNumber[2])
        response.skuNumber = value;

      default:
    }
    let dateValue = this.state.formData.startDate;
   // let yearValue = dateValue.getFullYear();
    response.sku = response.skuText + '-' + response.skuNumber + '-' + dateValue;
    this.setState({
      formData: response,
    });
  };

  handleStartDateChange = (event: any) => {
    const response = { ...this.state.formData };
    response.startDate = event;
    this.setState({
      formData: response,
    });
  };

  handleOnboardingStartDateChnage = (event: any) => {
    const response = { ...this.state.formData };
    let resposneOnBoarding = { ...response.onboardingInterval };
    resposneOnBoarding.startDate = event;
    response.onboardingInterval = resposneOnBoarding;
    this.setState({
      formData: response,
    });
  };
  handleOnboardingEndDateChnage = (event: any) => {
    const response = { ...this.state.formData };
    let resposneOnBoarding = { ...response.onboardingInterval };
    resposneOnBoarding.endDate = event;
    response.onboardingInterval = resposneOnBoarding;
    this.setState({
      formData: response,
    });
  };
  handleCourseAdminNames = (evn: any) => {
    // let value = _.get(evn,"label",[])
    // this.state.formData.goalLevels.push(evn)
    let updatedFormData = JSON.parse(JSON.stringify(this.state.formData));

     if (evn && evn.length > 0) {
      let goalList: any = [];
      evn.forEach((data: any) => {
        let element = {
          id: data.id,
          name: data.label,
        };
        goalList.push(element);
      });
//return goalList;
      updatedFormData.goalLevels = goalList;
      this.setState({
        formData: updatedFormData,
      });
    } else {
      //  let formData = { ...this.state.formData };
      updatedFormData.goalLevels = evn;
      this.setState({
        formData: updatedFormData,
      });
    }

    // this.state.formData.goalLevels.push(this.state.loggedInUserFullName)
  };
  handleRequestOptionChange = () => {
    const { packageByIdData } = this.props;
    const redirectUrl = redirectToCourseRequest(packageByIdData);
    this.props.history.push(redirectUrl);
  }

  requestContainerVisible = (requestList: any[] = []) => {
    return !!requestList.length;
  }

  handleSelectOption = (option: any) => {
    const { packageByIdData: { packageData } } = this.props;
    const courseRequestUrl = redirectToCourseRequest({ ...option, packageId: packageData._id, courseType: packageData.type });
    window.open(courseRequestUrl, '_blank');
  }
  
  render = () => {
    const { classes, viewPlanData, showVersionPopup, packageByIdData,setTreeData, treeData} = this.props;
    const { 
      // startDate, 
      // endDate, 
      subjects } = viewPlanData;
    const { packageData } = packageByIdData;
    const startDate = _.get(packageByIdData, 'packageData.startDate');
    const endDate = _.get(packageByIdData, 'packageData.expiryDate');
    let data = JSON.parse(JSON.stringify(viewPlanData));
    if(!_.isEmpty(viewPlanData) ){
     data = checkForDuplicateChapters(viewPlanData);
    }

    const handleTabClick = (tabIndex: number) => {
      if (tabIndex !== this.state.activeTab) {
        this.setState({ activeTab: tabIndex });
      }
    };
    const structure = formatterConvertorForCourse(viewPlanData,{},true);
    const { subjectSelection, packageResponse, formData, goalList, requests } = this.state;
    const hasValidSubjects = subjects && subjects.length;
    const skutext = _.split(formData.sku, '-');
    formData.skuText = skutext[0];
    // _.isUndefined(formData.skuNumber) ? '01' : skutext[1];
    const Onboarding = { ...formData.onboardingInterval };
    const status = _.get(packageResponse, 'status', 'draft');
    const requestId = getRequestId();
    const showTestVisibility=_.get(treeData,"displaySettings.showTestVisibility",false);
   return (
      <>          
       <RequestStatus />
        <div className={classes.coursePlan}>
          <div className={classes.coursePlanHeading}>
            <span>
             <h4> {requestId && <span>Requested</span>} Course Plan</h4>
              <p className={classes.dateRange}>{getFormattedDates(startDate, endDate)}</p>
            </span>

            <div className='coursePlanDropdownsRow'>
             {this.requestContainerVisible(requests.awaiting) &&
              <div className='coursePlanDropdowns'>
                <MyPATDropdown
                  title="Select Request Date"
                  dropdownItems={requests.awaiting}
                  placeHolderTitle="Requested On"   
                  labelKey='updatedAt'
                  onSelectOption={this.handleSelectOption}
                />
                <span className='placeholderTitle'>Awaiting Approval ({(requests.awaiting || []).length})</span>
              </div>
             }
             {this.requestContainerVisible(requests.approved) &&
              <div className='coursePlanDropdowns'>
                <MyPATDropdown
                  title="Select Request Date"
                  dropdownItems={requests.approved}
                  placeHolderTitle="Requested On"   
                  labelKey='updatedAt'
                  onSelectOption={this.handleSelectOption}
                />
                <span className='placeholderTitle'>Accepted ({(requests.approved || []).length})</span>
              </div>
             }
             {this.requestContainerVisible(requests.rejected) &&
              <div className='coursePlanDropdowns'>
                <MyPATDropdown
                  title="Select Request Date"
                  dropdownItems={requests.rejected}
                  placeHolderTitle="Requested On"   
                  labelKey='updatedAt'  
                  onSelectOption={this.handleSelectOption}
                />
                <span className='placeholderTitle'>Rejected ({(requests.rejected || []).length})</span>
              </div>
             }
             {this.requestContainerVisible(requests.closed) &&
               <div className='coursePlanDropdowns'>
                 <MyPATDropdown
                   title='Select Request Date'
                   dropdownItems={requests.closed}
                   placeHolderTitle='Requested On'
                   labelKey='updatedAt'
                   onSelectOption={this.handleSelectOption}
                 />
                 <span className='placeholderTitle'>Closed ({(requests.closed || []).length})</span>
               </div>
             }
            </div>
          </div>
        </div>
        <div className={classes.customTabs}>
          <div
            style={{
              borderBottom: '1px solid lightgrey',
              padding: '20px',
              marginTop: '-20px'
            }}
          >
            <ul style={{ display: 'flex', listStyle: 'none' }}>
              <li
                key='All Subjects'
                className={this.state.subjectSelection === 'All Subjects' ? classes.activeTab : classes.subTabs}
                onClick={() => this.setState({ subjectSelection: 'All Subjects' })}
              >
                {/* <li
                style={{
                  marginRight: '0.5em',
                  color: subjectSelection === 'All Subjects' ? 'blue' : 'lightgrey',
                  textDecoration: subjectSelection === 'All Subjects' ? 'underline' : 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                }}
                onClick={() => this.setState({ subjectSelection: 'All Subjects' })}
              > */}
                All Subjects
              </li>
              {hasValidSubjects &&
                subjects.map((subject: { name: string; chapterCount: number }) => (
                  <li
                    className={this.state.subjectSelection === subject.name ? classes.activeTab : classes.subTabs}
                    key={subject.name}
                    onClick={() => this.setState({ subjectSelection: subject.name })}
                  >
                    {/* <li
                    key={subject.name}
                    style={{
                      marginRight: '0.5em',
                      color: subjectSelection === subject.name ? 'blue' : 'lightgrey',
                      textDecoration: subjectSelection === subject.name ? 'underline' : 'none',
                      cursor: 'pointer',
                      fontWeight: 'bold',
                    }}
                    onClick={() => this.setState({ subjectSelection: subject.name })}
                  > */}
                    {subject.name}
                  </li>
                ))}
            </ul>
          </div>
          <div style={{ width: '100%' }}>
            {structure && Boolean(structure.length) && structure.map((phase: any, phaseIndex: number) => {
              if (
                subjectSelection === 'All Subjects' ||
                phase.subjects.filter((subject: any) => subject.name === subjectSelection && subject.chapterCount > 0).length
              ) {
                return (
                  <>
                    <PreviewTree packageEndDate={endDate} subjectTab={subjectSelection} key={phase.name} treeNode={phase} level={2} phaseIndex={phaseIndex} childIndex={phaseIndex} 
                                viewPlanData={viewPlanData} showTestVisibility={showTestVisibility}/>

                    {
                      phase.extraTests && phase.extraTests.length > 0 ? (
                        phase.extraTests.map((test: any, indexOfTest: number) => (
                        <PreviewTest
                          test={test}
                          isWeek={true}
                          phase={phase}
                          phaseIndex={phaseIndex}
                          isExtraTests={true}
                          packageEndDate={endDate}
                          showTestVisibility={showTestVisibility}
                        />
                        ))
                      ) : (
                        <></>
                      )
                    }


                    {/* <MidTermTest date={phase.endDate} subjects={phase.subjects} match={this.props.match} /> */}
                    {phase.milestoneTests && phase.milestoneTests.length ? (
                      phase.milestoneTests.map((test: any) => {
                        return (
                          <PreviewTest
                            test={test}
                            isWeek={false}
                            phase={phase}
                            packageEndDate={endDate}
                            phaseIndex={phaseIndex}
                            showTestVisibility={showTestVisibility}
                          />
                        );
                      })
                    ) : (
                        <></>
                      )}
                  </>
                );
              }
              return <></>;
            })}
          </div>
        </div>
        
      </>
    );
  };
}
const mapStateToProps = (state: any) => ({
  treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
  viewPlanData: _.get(state, 'courseMangementData.contentManagementData.viewPlanData', {}),
  packageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData', {})
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setViewPlanData: contentManagementAction.setViewPlanData,
      setTreeData: contentManagementAction.setTreeData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withRouter(withStyles(styles)(CoursePlanPreview)));
